<template>
    <span class="pricing-toggle">
      <span v-if="period=='monthly'">Monthly Billing</span>
      <span v-if="period=='yearly'">Yearly Billing</span>
    </span>
  </template>
  
  <script setup>
    import { ref } from 'vue'
    
    const emit = defineEmits(['period-changed'])
    
    const props = defineProps({
        initialPeriod: {
            type: String,
            default: 'monthly',
            validator: value => ['monthly', 'yearly'].includes(value)
        }
    })

    const period = ref(props.initialPeriod)
    function setPeriod(newPeriod) {
        period.value = newPeriod
        emit('period-changed', newPeriod)
    }
  </script>
  
  <style scoped>

  .pricing-toggle {
    max-width: 300px;
    margin: 20px auto;
  }
  

  </style>